const EMAIL_ACKNOWLEDGMENT_FREQUENCY_SETTING = {
  days: 'Days',
  week: 'Week',
  business_days: 'Business days',
} as const;

export default EMAIL_ACKNOWLEDGMENT_FREQUENCY_SETTING;
